import classes from './GuestInfo.module.css'
import InputForm from './InputForm'
import SubmitButton from './SubmitButton'
import { useEffect } from 'react'

import { quoteActions } from '../../store/quote-slice'

import { useDispatch } from 'react-redux'

import Button from '../UI/Button'

const GuestInfo = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const backButtonClickHandler = () => {
    dispatch(quoteActions.setQuoteAcceptedToggle())
  }

  return (
    <div className={classes.formContainer}>
      <div className={classes.backButtonContainer}>
        <Button onClick={backButtonClickHandler} buttonText="Back" />
      </div>

      <InputForm />
      <SubmitButton />
    </div>
  )
}

export default GuestInfo
